import { h, Component } from "preact";
import cs from "classnames";
import { AutodataCustomEventTypes } from "../../../autodata/src/ts/types";
import { AppConfig } from "../ts/types";

enum Answers {
  YES = "yes",
  NO = "no",
}

interface Props {
  appConfig: AppConfig;
}

interface State {
  answer: Answers | null;
  feedbackSuccessfullySent: boolean;
}

export default class Main extends Component<Props, State> {
  constructor() {
    super();

    this.state = {
      feedbackSuccessfullySent: false,
      answer: null,
    };
  }

  componentDidUpdate(_, prevState) {
    if (prevState.answer === null && this.state.answer !== null) {
      dispatchEvent(
        new CustomEvent(AutodataCustomEventTypes.ON_CLICK_USEFUL_QUESTION, {
          detail: {
            dataEvent: {
              ...this.props.appConfig.dataEvent,
              label: this.props.appConfig.dataEvent.faq_question,
              value: 1,
              category: "faq|questionFooter",
              action: `rate|${this.state.answer}`,
            },
          },
        })
      );
    }
  }

  onSubmitAnswer(answer: Answers) {
    this.setState({
      answer,
      feedbackSuccessfullySent: true,
    });
  }

  render({ appConfig }: Props, { feedbackSuccessfullySent }: State) {
    const usefulQuestionCSSClassnames = cs("usefulQuestion", {
      submitted: feedbackSuccessfullySent,
    });

    return (
      <div className="app-feedback-useful-question">
        <div className={usefulQuestionCSSClassnames}>
          <div className="container grid-lg">
            <div className="columns">
              <div className="column col-12 col-md-11 col-mx-auto usefulQuestionWrapper">
                <h4 className="usefulQuestion__title">
                  {appConfig.i18n.title}
                </h4>
                <p className="usefulQuestion__successMsg">
                  {appConfig.i18n.successfulMessage}
                </p>
                <div className="usefulQuestion__options columns">
                  <div className="column col-2 col-md-4 usefulQuestion__options_item">
                    <button
                      className="usefulOption"
                      disabled={feedbackSuccessfullySent}
                      onClick={() => this.onSubmitAnswer(Answers.YES)}
                    >
                      {appConfig.i18n.buttonYes}
                    </button>
                  </div>
                  <div className="column col-2 col-md-4">
                    <button
                      className="usefulOption "
                      disabled={feedbackSuccessfullySent}
                      onClick={() => this.onSubmitAnswer(Answers.NO)}
                    >
                      {appConfig.i18n.buttonNo}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
